/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface ConversationMetadataProps {
  name: string | null;
}

export class ConversationMetadataRecord extends Record<ConversationMetadataProps>({
  name: null as any,
}) {
  public static fromJS(json: { name: string | null }): ConversationMetadataRecord {
    if (json == null) {
      throw new Error('ConversationMetadataRecord.fromJS: parameter cannot be null');
    }
    return new ConversationMetadataRecord({
      name: json.name,
    });
  }

  public static fromJSUnsafe(json: { name: string | null }): [ConversationMetadataRecord, Error[]] {
    if (json == null) {
      throw new Error('ConversationMetadataRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new ConversationMetadataRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      name: tryOrDefault(
        () => json.name,
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: ConversationMetadataProps) {
    super(props);
    if (props == null) {
      throw new Error('ConversationMetadataRecord constructor parameter cannot be null');
    }
  }
}

export abstract class ConversationMetadataViewModelBase implements ConversationMetadataProps {
  protected readonly _props: ConversationMetadataProps;
  private _json?: ConversationMetadataProps;

  get name(): string | null {
    return this._props.name;
  }

  constructor(props: ConversationMetadataProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        name: this._props.name,
      };
    }
    return this._json;
  }
}
